export enum Roles {
  creador_expediente = 20,
  fiscalizador = 21,
  prestador = 35,
  presidente = 36
}

export default Roles;